export const fetchOrThrow = async (request: RequestInfo, init?: RequestInit): Promise<Response> => {
  const response = await fetch(request, init);

  if (!response.ok) {
    throw response;
  }

  return response;
};
